import React, { useEffect, useState } from "react";
import UserAuth from "../../middleware/UserAuth";
import Layout from "../../components/web/Layout";
import Container from "../../components/ui/container/Container";
import { TiMicrophoneOutline } from "react-icons/ti";

import { Helmet } from "react-helmet";
import InfiniteScroll from "react-infinite-scroll-component";
import { getProductsApi } from "../../utils/guest/api";
import ProductCard from "../../components/web/product/ProductCard";
import ProductCardSmall from "../../components/web/product/ProductCardSmall";
import { useParams } from "react-router-dom";
import HorizontalMultiSelect from "../../components/ui/form/HorizontalMultiSelect";
import VegNonVegToggle from "../../components/ui/form/VegNonVegToggle";
import ProductCardSmallShimmer from "../../components/web/product/ProductCardSmallShimmer";
import VendorSlider from "./VendorSlider";

function Products() {
  const { id } = useParams();

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [cardType, setCardType] = useState("small");

  const [filters, setFilters] = useState({
    selectedMainCategories: [],
    priceRange: { min: 0, max: 999999 },
    search: "",
    itemCategories: [],
    foodTypes: [],
  });

  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [sliders, setSliders] = useState([]);
  const [food, setFoodType] = useState([]);

  const loadData = async (reset = false) => {
    try {
      setIsLoading(true);
      const result = await getProductsApi(page, 20, filters, "v1", id);
      if (!result) return;

      setCategories(result?.uniqueItemCategories || []);
      setFoodType(result?.uniqueFoodTypes || []);
      setSliders(result?.sliders || []);

      const newProducts = result.products || [];
      const totalPages = result.pagination?.totalPages || 1;

      setItems((prev) => (reset ? newProducts : [...prev, ...newProducts]));

      if (page >= totalPages) {
        setHasMore(false);
      } else {
        setPage((prev) => prev + 1);
      }
    } catch (err) {

      console.error("❌ Error fetching products:", err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setPage(1);
    setItems([]);
    setHasMore(true);
    loadData(true);
  }, [filters]);

  const handleSearch = (e) => {
    setFilters((prev) => ({ ...prev, search: e.target.value }));
  };

  const categoryOptions = categories.map((c) => ({ value: c, label: c }));

  const toppingOptions = food.map((c) => ({ value: c, label: c }));
  const placeholders = [
    "Search dishes...",
    "Search snacks...",
    "Search drinks...",
    "Search sweets...",
  ];
  const [placeholder, setPlaceholder] = useState(placeholders[0]);
  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % placeholders.length;
      setPlaceholder(placeholders[index]);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const handleVoiceSearch = () => {
    if (!("webkitSpeechRecognition" in window)) {
      alert("Voice search not supported in this browser");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-IN";
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.start();

    recognition.onresult = (event) => {
      const spokenText = event.results[0][0].transcript;
      handleSearch({ target: { value: spokenText } });
    };
  };


  return (
    <Layout>
      <UserAuth>
        <Container className="mb-6  ">
          <Helmet>
            <title>MOBO EAT | Products</title>
          </Helmet>

          <div className="mb-3">
            <VendorSlider isLoading={isLoading} data={sliders} />
          </div>
          <div className="bg-white shadow-lg rounded-2xl p-4 md:p-5 mb-6 border">
            <div className="flex  sm:items-center justify-between gap-3 mb-4">
              <div>
                <h2 className="text-lg font-semibold text-gray-800">
                  Filter Products
                </h2>
              </div>
              <VegNonVegToggle
                value={filters.foodTypes}
                onChange={(val) =>
                  setFilters({ ...filters, foodTypes: val })
                }
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="col-span-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Search by Name
                </label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder={placeholder}
                    value={filters.search}
                    onChange={handleSearch}
                    className="w-full border rounded-xl px-10 py-2.5 text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition"
                  />

                  <svg
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                    width="18"
                    height="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-4.35-4.35m1.35-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>

                  <button
                    type="button"
                    onClick={handleVoiceSearch}
                    className="absolute right-3 top-1/2 -translate-y-1/2 bg-red-50 p-2 rounded-full text-gray-500 hover:text-green-600 hover:bg-black"
                  >
                    <TiMicrophoneOutline />
                  </button>
                </div>
              </div>

              <div className="col-span-full">
                <HorizontalMultiSelect
                  label="Categories"
                  options={categoryOptions}
                  value={filters.itemCategories}
                  onChange={(val) =>
                    setFilters({ ...filters, itemCategories: val })
                  }
                />
              </div>
            </div>
          </div>


          {isLoading && page === 1 ? (
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {Array.from({ length: 6 }).map((_, index) => (
                <ProductCardSmallShimmer key={index} />
              ))}
            </div>

          ) : items.length === 0 ? (
            <p className="text-center py-5 text-gray-500">No products found</p>
          ) : (
            <InfiniteScroll
              dataLength={items.length}
              next={loadData}
              hasMore={hasMore}
              loader={
                <div className="grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
                  {Array.from({ length: 6 }).map((_, index) => (
                    <div key={index}>
                      <ProductCardSmallShimmer />
                    </div>
                  ))}
                </div>
              }
              endMessage={
                <p className="text-center py-4 text-gray-400">
                  🎉 No more products
                </p>
              }
            >

              <div
                className={`grid ${cardType === "small"
                  ? "grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4"
                  : "grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4"
                  }`}
              >



                {items.map((product) =>
                  cardType === "small" ? (
                    <div key={product._id}>
                      <ProductCardSmall product={product} />
                    </div>
                  ) : (
                    <div key={product._id}  >
                      <ProductCard key={product._id} product={product} />
                    </div>
                  )
                )}
              </div>
            </InfiniteScroll>
          )}
        </Container>
      </UserAuth>
    </Layout>
  );
}

export default Products;
